import Swiper from 'swiper/bundle'

export default class SliderInsta {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    const swiperEl = this.el.querySelector('.swiper')
    if (!swiperEl) return

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      loop: true,
      speed: 800,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
    })
  }
}
